<template>
  <keep-alive>
    <b-modal
        :id="id"
        ref="modal"
        :title="modalTitle"
        no-close-on-backdrop
        centered
        title-class="font-18"
        v-bind="$attrs"
        @ok="handleOk"
    >
      <validation-observer v-if="!loading" ref="form_observer">
        <component
            :is="form"
            ref="form"
            v-model="model"
            :errors="errors"
            :is-valid.sync="isValid"
            is-modal="true"
            v-bind="formProps"
            v-on="formListeners"
        >
        </component>
      </validation-observer>
      <div v-if="loading" class="d-flex">
        <i class="bx bx-loader bx-spin font-size-16 align-middle mx-auto"></i>
      </div>
      <user-approver-blocked-modal ref="warning_modal" />
      <template #modal-footer="{ ok, cancel}">
        <b-button size="md" variant="outline-dark" @click="cancel()">
          Batal
        </b-button>
        <b-button
            :disabled="updating || loading"
            size="md"
            variant="primary"
            @click="ok()"
        >
          <i
              v-if="updating"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Simpan
        </b-button>
      </template>
    </b-modal>
  </keep-alive>
</template>

<script>
import FormsModel from "@/components/forms/user";
import ModelEditModal from "@/components/modals/modal-edit.vue";
import UserApproverBlockedModal from "@/components/modals/user-approver-blocked-modal.vue";

export default {
  extends: ModelEditModal,
  components: {
    UserApproverBlockedModal,
  },
  props: {
    id: { type: String, required: true },
    modalTitle: {
      default() {
        return this.lodash.startCase(`${this.$t('Edit')} ${this.$t("users.singular")}`);
      },
    },
    resourceRoute: { default: "users" },
    modelVariable: { default: "user" },
    form: {
      type: Object,
      default: function () {
        return FormsModel;
      },
    },
    formProps: {
      type: Object,
      default: function () {
        return {};
      },
    },
    formListeners: {
      type: Object,
      default: function () {
        return {};
      },
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      isValid: true,
      updating: false,
      model: {
        ...this.initialValue,
      },
      errors: {},
    };
  },
  methods: {
    fetchModel(user_id) {
      this.loading = true;
      return this.$axios
        .get(`/users/${user_id}`, { params: { with: "user,roles" } })
        .then((response) => {
          const { data: { data } } = response;
          this.model = data;
          if (data.roles.length > 0) {
            this.model.role_id = data.roles[0].id;
          }
          return response;
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => {
          this.loading = false;
        });
    },
    handleUpdate(value) {
      this.updating = true;
      return this.update(value)
        .then((res) => {
          const { data: { data } } = res;
          this.$toast(this.$t("You've updated {something}", { something: this.getModelName() }), {
            type: 'success'
          })
          this.$emit("updated", data);
          this.$refs.modal.hide();
        })
        .catch((error) => {
          window.console.log('error', error.response)
          if (error.response && error.response.status === 422 && error.response.data.errors && error.response.data.errors.is_bound_to_approval) {
            window.console.log('show warning modal')
            this.$refs.warning_modal.show({ name: this.model.name });
          } else {
            this.failedAlert(error);
          }
        })
        .finally(() => {
          this.updating = false;
        });
    },
    update(value) {
      return this.$axios
        .put(`/users/${value.id}`, {
          ...value,
        })
        .catch((e) => {
          if (e.response && e.response.data) {
            this.errors = e.response.data.errors;
          }
          throw e;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal-title {
    font-weight: 800;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    color: #0084f3;
  }

  .modal-dialog {
    max-width: 720px !important;
  }

}
</style>
